import React from 'react'
import { useTranslation } from 'react-i18next'

import { BoxInfoWithButton } from 'shared/components/BoxInfo'

interface IErrorFallbackProps {
	resetErrorBoundary: (...args: Array<unknown>) => void
	error: Error
}

function ErrorFallbackComponent({ resetErrorBoundary }: IErrorFallbackProps) {
	const { t } = useTranslation()

	const ResetButton = () => {
		return (
			<button
				type="button"
				className="btn btn-primary"
				onClick={resetErrorBoundary}>
				{t('TryAgain')}
			</button>
		)
	}

	return (
		<div className="error-fallback-container">
			<BoxInfoWithButton
				css="fail"
				button={<ResetButton />}
				message={t('ErrorOnRender')}
			/>
		</div>
	)
}

export default ErrorFallbackComponent
